module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-a-replace-vehicle"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('cards', {
    attrs: {
      "data": _vm.selectedDates
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "format": 'yyyy-mm-dd hh:ii',
      "initialDate": _vm.$dateFormat(_vm.initialStart, 'YYYY-MM-DD HH:mm')
    },
    model: {
      value: (_vm.bookRequest.start),
      callback: function($$v) {
        _vm.$set(_vm.bookRequest, "start", $$v)
      },
      expression: "bookRequest.start"
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("End"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "format": 'yyyy-mm-dd hh:ii',
      "initialDate": _vm.$dateFormat(_vm.initialEnd, 'YYYY-MM-DD HH:mm')
    },
    model: {
      value: (_vm.bookRequest.end),
      callback: function($$v) {
        _vm.$set(_vm.bookRequest, "end", $$v)
      },
      expression: "bookRequest.end"
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])])])]), _c('div', {
    staticClass: "row columns"
  }, [(_vm.loading) ? _c('loading-spinner') : _vm._e(), _vm._l((_vm.slotsByLots), function(slots, key) {
    return _c('div', {
      staticClass: "grouped card",
      style: (_vm.gridStyle(slots))
    }, [_c('h1', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle) {
      return _c('vehicle', {
        attrs: {
          "item": vehicle,
          "type": "search-result"
        }
      }, [_c('div', {
        staticClass: "text-center"
      }, [_c('button', {
        staticClass: "button small",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.cancelAndBook(vehicle)
          }
        }
      }, [_vm._v("Cancel & Book")]), _c('span', [_vm._v(" ")]), _c('button', {
        staticClass: "button small",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.voidAndBook(vehicle)
          }
        }
      }, [_vm._v("Void & Book")]), _c('button', {
        staticClass: "button small",
        on: {
          "click": function($event) {
            return _vm.replaceVehicleSlot(vehicle)
          }
        }
      }, [_vm._v("Force replace vehicle slot")])])])
    })], 2)
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-083ca66b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/FindAReplaceVehicle.vue
// module id = 2229
// module chunks = 1